<template>
  <div class="mf-loading-container">
    <img src="./loading.gif" />
  </div>
</template>
<script type="text/ecmascript-6">
const COMPONENT_NAME = 'loading'

export default {
  name: COMPONENT_NAME
}
</script>
<style scoped>
.mf-loading-container img {
  width: 0.533333rem;
  height: 0.533333rem;
  display: block;
}
</style>
